import React, { useEffect } from 'react'
import { AiFillHeart, AiOutlineShoppingCart } from 'react-icons/ai'
import { FaEye } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import Ratings from '../Ratings'
import { add_to_card, messageClear, add_to_wishlist } from '../../store/reducers/cardReducer'

const FeatureProducts = ({ products }) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { userInfo } = useSelector(state => state.auth)
    const { successMessage, errorMessage } = useSelector(state => state.card)

    const add_card = (id) => {
        if (userInfo) {
            dispatch(add_to_card({
                userId: userInfo.id,
                quantity: 1,
                productId: id
            }))
        } else {
            navigate('/login')
        }
    }
    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage)
            dispatch(messageClear())
        }
        if (errorMessage) {
            toast.error(errorMessage)
            dispatch(messageClear())
        }
    }, [errorMessage, successMessage])

    const add_wishlist = (pro) => {
        dispatch(add_to_wishlist({
            userId: userInfo.id,
            productId: pro._id,
            name: pro.name,
            price: pro.price,
            image: pro.images[0],
            discount: pro.discount,
            rating: pro.rating,
            slug: pro.slug
        }))
    }
    return (
        <div className='w-[85%] flex flex-wrap mx-auto'>
            <div className='w-full'>
                <div className='text-center flex justify-center items-center flex-col text-4xl text-gray-600 font-medium relative pb-[45px]'>
                    <h2>Feature Products</h2>
                    <div className='w-[230px] h-[2px] bg-[#7fad39] mt-1'></div>
                </div>
            </div>
            <div className="w-full grid grid-cols-4 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6">
            {products.map((p, i) => (
    <div key={i} className="bg-white rounded-lg overflow-hidden transition-all duration-300 hover:shadow-lg">
      <div className="relative">
        {/* Product Image */}
        <div className="relative aspect-square overflow-hidden bg-gray-100">
          <img
            className="w-full h-full object-cover object-center transform transition-transform duration-300 hover:scale-105"
            src={p.images[0] || "/placeholder.svg"}
            alt={p.name}
          />

          {/* Discount Badge */}
          {p.discount > 0 && (
            <div className="absolute right-2 top-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded">
              {p.discount}% OFF
            </div>
          )}

          {/* Wishlist Button */}
          <button
            onClick={() => add_wishlist(p)}
            className="absolute left-2 top-2 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
          >
            <AiFillHeart className="text-gray-400 hover:text-red-500 transition-colors" />
          </button>
        </div>

        {/* Quick Action Buttons */}
        <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/50 to-transparent opacity-0 transition-opacity duration-300 hover:opacity-100">
          <div className="flex justify-center gap-2">
            <Link
              to={`/product/details/${p.slug}`}
              className="w-8 h-8 flex items-center justify-center bg-white rounded-full hover:bg-gray-100 transition-colors"
            >
              <FaEye className="text-gray-600" />
            </Link>
            <button
              onClick={() => add_card(p._id)}
              className="w-8 h-8 flex items-center justify-center bg-white rounded-full hover:bg-gray-100 transition-colors"
            >
              <AiOutlineShoppingCart className="text-gray-600" />
            </button>
          </div>
        </div>
      </div>

      {/* Product Info */}
      <div className="p-4">
        {/* Product Name */}
        <h2 className="text-gray-800 font-medium mb-2 line-clamp-2">{p.name}</h2>

        {/* Price and Rating */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            {p.discount > 0 ? (
              <>
                <span className="text-lg font-bold text-gray-900">
                  Kes{((p.price * (100 - p.discount)) / 100).toFixed(0)}
                </span>
                <span className="text-sm text-gray-500 line-through">Kes {p.price}</span>
              </>
            ) : (
              <span className="text-lg font-bold text-gray-900">Kes {p.price}</span>
            )}
          </div>
          <div className="flex text-yellow-400">
            {[...Array(5)].map((_, index) => (
              <svg
                key={index}
                className={`w-4 h-4 ${index < p.rating ? "fill-current" : "text-gray-300"}`}
                viewBox="0 0 20 20"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ))}
          </div>
        </div>

        {/* Add to Cart Button */}
        <button
          onClick={() => add_card(p._id)}
          className="w-full mt-4 bg-gray-900 text-white py-2 rounded hover:bg-gray-800 transition-colors"
        >
          Add to Cart
        </button>
      </div>
    </div>
  ))}
    </div>
    </div>
    )
}

export default FeatureProducts